import axios from "axios";
import { ethers } from "ethers";
import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/AppLoader";

const TOKEN = localStorage.getItem("token");
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Authorization"] =
  TOKEN && TOKEN.includes("Bearer") ? TOKEN : `Bearer ${TOKEN}`;

const DEBUG = process.env.NODE_ENV === "development";

axios.interceptors.response.use(
  (config) => config,
  (error) => {
    const { response: { data } } = error;

    if (DEBUG) {
      // refresh page if token is expired
      if (data.message = "Unauthenticated.") {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

interface Context {
  user: any;
  isAdminAddress: boolean;
  roles_permissions: any;
  permissions: string[];
  connectedAddress: string;
  setState: (object: Partial<Context>) => void;
  logout: () => void;
}

const initialContext: Context = {
  user: null,
  isAdminAddress:
    window.ethereum?.selectedAddress?.toLowerCase() ===
    process.env.REACT_APP_ADMIN_ADDRESS?.toLowerCase(),
  roles_permissions: [],
  permissions: [],
  connectedAddress: window.ethereum?.selectedAddress,
  setState: (): void => { },
  logout: (): void => { },
};
const AppContext = createContext<Context>(initialContext);

const AppContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const navigate = useNavigate();
  const [state, setStates] = useState<Context>(initialContext);
  const [loading, setLoading] = useState<boolean>(!!TOKEN);

  const setState = (object: any) => {
    setStates((prevState: any) => ({ ...prevState, ...object }));
  };

  const getInitData = async () => {
    let userData;
    setLoading(true);

    try {
      const { data } = await axios.get("/profile/getUserData");
      userData = data.user;
    } catch (error: any) {
      navigate("/login", { replace: true });
      localStorage.removeItem("token");
      setLoading(false);

      toast.error(error.response.data.message);
    }

    try {
      const roles_and_permissions = await Promise.all([
        userData?.permissions.includes("view_system_role")
          ? axios.get("/roles/get-roles", {
            params: {
              getAll: 1,
            },
          })
          : Promise.resolve({ data: [] }),

        axios.get("/roles/get-permissions"),
      ]);

      setState({
        user: userData,
        roles_permissions: roles_and_permissions[0].data,
        permissions: roles_and_permissions[1].data.data,
      });
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  const logout = async () => {
    try {
      await axios.post("/logout");
      navigate("/login");
      localStorage.removeItem("token");
      setState({ user: null });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (TOKEN) {
      getInitData();
    }
  }, []);

  if (loading) return <AppLoader />;

  return (
    <AppContext.Provider value={{ ...state, logout, setState }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
